export const GET_WORKFLOWTYPES = "/workflowTypes"
